
if(!customElements.get('wlsn-5050')) {
  class WLSN5050 extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        mediaBlock: 'js-wlsn-5050-media-block',
        mediaPosition: 'js-wlsn-5050-media-position-small-screens',
      }
    }

    get elements() {
      return {
        mediaBlock: this.querySelector(`.${this.classes.mediaBlock}`),
        mediaPosition: this.querySelector(`.${this.classes.mediaPosition}`),
      }
    }

    connectedCallback() {
      this.initMediaSwap();
    }

    disconnectedCallback() {
      if (this.mediaQuery && this.handleMediaChange) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        } else {
          // Fallback for older browsers
          this.mediaQuery.removeListener(this.handleMediaChange);
        }
      }
    }

    initMediaSwap() {
      const { mediaPosition, mediaBlock } = this.elements;
      
      if (!mediaPosition || !mediaBlock) {
        return;
      }

      // Store original positions for restoration
      if (!this.originalPositions) {
        this.originalPositions = {
          mediaBlock: {
            parent: mediaBlock.parentNode,
            nextSibling: mediaBlock.nextSibling
          },
          mediaPosition: {
            parent: mediaPosition.parentNode,
            nextSibling: mediaPosition.nextSibling
          }
        };
      }

      // Create media query for screens smaller than 1023px
      this.mediaQuery = window.matchMedia('(max-width: 1023px)');
      
      // Handle media query changes
      this.handleMediaChange = (e) => {
        if (e.matches) {
          // Screen is smaller than 1023px - replace mediaPosition with mediaBlock
          this.swapMediaElements();
        } else {
          // Screen is 1024px or larger - restore original positions
          this.restoreMediaElements();
        }
      };

      // Set initial state
      this.handleMediaChange(this.mediaQuery);
      
      // Listen for changes (using addEventListener for modern browsers)
      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
      } else {
        // Fallback for older browsers
        this.mediaQuery.addListener(this.handleMediaChange);
      }
    }

    swapMediaElements() {
      const { mediaPosition, mediaBlock } = this.elements;
      
      if (!mediaPosition || !mediaBlock || this.isSwapped) {
        return;
      }

      // Get the position where mediaPosition is located
      const mediaPositionParent = mediaPosition.parentNode;
      const mediaPositionNextSibling = mediaPosition.nextSibling;

      // Move mediaBlock to replace mediaPosition
      if (mediaPositionNextSibling) {
        mediaPositionParent.insertBefore(mediaBlock, mediaPositionNextSibling);
      } else {
        mediaPositionParent.appendChild(mediaBlock);
      }

      // Hide original mediaPosition
      mediaPosition.style.display = 'none';
      
      this.isSwapped = true;
    }

    restoreMediaElements() {
      const { mediaPosition, mediaBlock } = this.elements;
      
      if (!this.isSwapped || !this.originalPositions) {
        return;
      }

      // Restore mediaBlock to original position
      const originalBlockParent = this.originalPositions.mediaBlock.parent;
      const originalBlockNextSibling = this.originalPositions.mediaBlock.nextSibling;
      
      if (originalBlockNextSibling) {
        originalBlockParent.insertBefore(mediaBlock, originalBlockNextSibling);
      } else {
        originalBlockParent.appendChild(mediaBlock);
      }

      // Restore mediaPosition visibility
      if (mediaPosition) {
        mediaPosition.style.display = '';
      }
      
      this.isSwapped = false;
    }
  }
  customElements.define('wlsn-5050', WLSN5050);
}